// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const products = {
  id: "products",
  title: "Products",
  type: "group",
  children: [
    {
      id: "products",
      title: "Products",
      type: "item",
      url: "/products",
    },
    {
      id: "products-categories",
      title: "Products Categories",
      type: "item",
      url: "/products/categories",
    },
    {
      id: "stock",
      title: "Stock",
      type: "item",
      url: "/stock",
    },
    {
      id: "transactions",
      title: "Transactions",
      type: "item",
      url: "/transactions",
    },
  ],
};

export default products;
